import { render } from "./PaymentMethodStep.vue?vue&type=template&id=3c03d687"
import script from "./PaymentMethodStep.vue?vue&type=script&lang=js"
export * from "./PaymentMethodStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__